import Type from '../type';
import registry from './registry';

type EventListener = {
	listener: Function,
	once: boolean,
	passive: boolean,
	type: string,
	useCapture: boolean,
}

export function getEventListeners(target: EventTarget, eventName: string): Array<EventListener>
{
	const listeners = [];
	if (Type.isEventTargetLike(target))
	{
		const events = registry.get(target);
		if (events[eventName])
		{
			events[eventName].forEach((listener) => {
				listeners.push({
					type: eventName,
					listener,
				});
			});
		}
	}

	return listeners;
}
